module.exports = __webpack_public_path__ + "img/image_pc.69e511f8.png";